import type { BlockComponentStateId, BlockComponentType, BlockId } from '../../types/block';
import { EventTypeEnum } from '../../types/event';
import type { ItemsType } from '../../types/items';
import type { StyleObject } from '../../types/styleObject';

export enum SwipeableStackContentType {
  STATIC = 'STATIC',
  DYNAMIC = 'DYNAMIC',
}

export enum AllowedSwipesEnum {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
  ALL = 'all',
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export type DynamicSwipeableStackContent = {
  type: SwipeableStackContentType.DYNAMIC;
  data?: string;
  primaryKey?: string;
  blockId?: BlockId;
  collectChildStates?: boolean;
};

export type StaticSwipeableStackContent = {
  type: SwipeableStackContentType.STATIC;
  items?: ItemsType[];
};

type SwipeableStackContent = DynamicSwipeableStackContent | StaticSwipeableStackContent;

type SwipeableStackAppearance = {
  enableLoop?: boolean;
  allowedSwipes?: AllowedSwipesEnum;
  maxDisplayCount?: number;
  backCardScale?: number;
  backCardOffset?: {
    horizontal?: number;
    vertical?: number;
  };
  styles?: Pick<
    StyleObject,
    'height' | 'maxHeight' | 'minHeight' | 'width' | 'minWidth' | 'maxWidth'
  >;
};

export type SwipeableStackComponentType = BlockComponentType<
  'SwipeableStack',
  SwipeableStackContent,
  SwipeableStackAppearance
>;

export type SwipeableStackComponentState = {
  currentItemIndex: number;
  totalItemsCount: number;
  events?: {
    [EventTypeEnum.OnSelectItem]?: {
      selectedItem: unknown | undefined;
      selectedItemIndex: number;
    };
    [EventTypeEnum.OnSwipeItem]?: {
      swipedItem: unknown | undefined;
      swipedItemIndex: number;
      swipeDirection: 'left' | 'right' | 'up' | 'down';
    };
  };
};

export type SwipeableStackComponentStateType = Pick<
  SwipeableStackComponentType,
  'appearance' | 'componentType'
> & {
  content: SwipeableStackContent;
} & SwipeableStackComponentState &
  BlockComponentStateId;
